import { snakeToCamel } from '../utils/CaseUtils';
import {
  ActiveDriversETL,
  SelectedDriverETL,
} from '../utils/ExtractTransformLoad/ActiveDriversELT';
import {
  OrderHistoryETL,
} from '../utils/ExtractTransformLoad/OrderHistoryETL';
import { getDriversCalendarHistory } from './DriverCalendarHistory';
import { RestaurantsETL } from '../utils/ExtractTransformLoad/RestaurantsETL';
import { ActiveOrdersETL } from '../utils/ExtractTransformLoad/ActiveOrdersETL';

import { api } from './Api';
import { requirePortalAccess } from './PortalSession';

export const getActiveDrivers = async () => {
  requirePortalAccess();
  const response = await api.get('/deliveryops/drivers');
  return ActiveDriversETL(response);
};

export const getSelectedDriver = async (driverId) => {
  const access = requirePortalAccess(driverId);
  const response = await api.get(`/deliveryops/drivers/${driverId}`);
  if (access.driver && String(response?.id) !== access.id) {
    throw new Error('Driver identity mismatch');
  }
  return SelectedDriverETL(response);
};

export const getOrderHistory = async ({ page = 1, dateRange }) => {
  const formattedDate = dateRange && [
    parseInt(new Date(dateRange[0])?.getTime() / 1000, 10),
    parseInt(new Date(dateRange[1])?.getTime() / 1000, 10),
  ];

  const response = await api.get('/deliveryops/orders/history', {
    page,
    ...(formattedDate
      ? { start: formattedDate[0], end: formattedDate[1] }
      : {}),
  });

  return {
    ...snakeToCamel(response),
    results: OrderHistoryETL(response.results),
  };
};

export const getDriversHistory = getDriversCalendarHistory;

export const getOrderDetails = async (deliveryId) => {
  const response = await api.get(`/deliveryops/orders/${deliveryId}`);
  return snakeToCamel(response);
};

export const getActiveRestaurants = async () => {
  requirePortalAccess();
  const response = await api.get('/deliveryops/restaurants');
  return RestaurantsETL(response);
};

export const getActiveOrders = async () => {
  requirePortalAccess();
  const response = await api.get('/deliveryops/orders/active');
  return ActiveOrdersETL(response);
};
